import { render, staticRenderFns } from "./changeRuleConfig.vue?vue&type=template&id=76d34b67&scoped=true&"
import script from "./changeRuleConfig.vue?vue&type=script&lang=js&"
export * from "./changeRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./changeRuleConfig.vue?vue&type=style&index=0&id=76d34b67&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d34b67",
  null
  
)

export default component.exports